import { DetailedHTMLProps, HTMLAttributes } from 'react';
import Image from 'next/image';
import { AnimationOnScroll } from 'react-animation-on-scroll';
import styles from './lets-link-development.module.css';

import bg from '../../public/letslink/development/bg.jpg';
import application from '../../public/letslink/development/application.png';
import swift from '../../public/letslink/development/swift.png';
import swiftUi from '../../public/letslink/development/swift-ui.png';
import kotlin from '../../public/letslink/development/kotlin.png';
import java from '../../public/letslink/development/java.png';
import android from '../../public/letslink/development/android.png';
import Place from '../../public/letslink/development/Place.png';
import docker from '../../public/letslink/development/docker.png';
import redis from '../../public/letslink/development/redis.png';
import php from '../../public/letslink/development/php.png';
import laravel from '../../public/letslink/development/laravel.png';
import {
  Banner,
  Container,
  Htag,
  HtagAlign,
  HtagVariant,
  Paragraph,
} from '../../components';

export interface LetsLinkDevelopmentProps
  extends DetailedHTMLProps<HTMLAttributes<HTMLElement>, HTMLElement> {}

export default function LetsLinkDevelopment({
  className,
  ...props
}: LetsLinkDevelopmentProps) {
  return (
    <section {...props}>
      <div className={styles.development}>
        <Container variant="container_small">
          <AnimationOnScroll
            delay={0}
            offset={200}
            animateOnce
            duration={1.2}
            animateIn="animate__fadeInDown"
          >
            <Htag
              tag="h2"
              align={HtagAlign.center}
              variant={HtagVariant.h2}
              className={styles.development_title}
            >
              development
            </Htag>
          </AnimationOnScroll>
          <AnimationOnScroll
            delay={500}
            offset={100}
            animateOnce
            duration={1.2}
            animateIn="animate__fadeInDown"
          >
            <Paragraph className={styles.development_text}>
              Since LinkApp main idea is to connect like-minded people based on
              their interests, we chose green as a main color of the app design.
              Green is about energy, fresh ideas, willingness to open new
              things. The overall aesthetics are minimalistic and clean. It
              keeps users focused on the core features of the app.
            </Paragraph>
          </AnimationOnScroll>
        </Container>
        <AnimationOnScroll
          delay={800}
          offset={50}
          animateOnce
          duration={1.2}
          animateIn="animate__fadeIn"
        >
          <div className={styles.development_image}>
            <Image
              alt="Linkapp preview screen"
              src={application}
              blurDataURL={application.blurDataURL}
              className={styles.development_phone}
            />
            <Image
              alt="Linkapp background"
              className={styles.background}
              layout="fill"
              objectFit="contain"
              src={bg}
            />
          </div>
        </AnimationOnScroll>
      </div>
      <Container variant="container_small">
        <div className={styles.development__item}>
          <div className={styles.development_box}>
            <AnimationOnScroll
              delay={0}
              offset={200}
              animateOnce
              duration={1.2}
              animateIn="animate__fadeInDown"
            >
              <Htag
                tag="h4"
                align={HtagAlign.center}
                variant={HtagVariant.h4}
                className={styles.development_titleSecond}
              >
                ios stack of tech used
              </Htag>
            </AnimationOnScroll>

            <Paragraph className={styles.development_textSecond}>
              The app is written on Swift&apos;s latest 5.1 version. We&apos;ve
              also integrated Apple Maps and created a couple of custom-written
              libraries.
            </Paragraph>
          </div>
          <AnimationOnScroll
            delay={0}
            offset={200}
            animateOnce
            duration={1.2}
            animateIn="animate__fadeInDown"
          >
            <Banner
              Start={<Image alt="Swift logo" src={swift} width={326} height={101} />}
              End={<Image alt="SwiftUi logo" src={swiftUi} width={314} height={101} />}
            />
          </AnimationOnScroll>
        </div>
        <div className={styles.development__item}>
          <div className={styles.development_box}>
            <AnimationOnScroll
              delay={0}
              offset={200}
              animateOnce
              duration={1.2}
              animateIn="animate__fadeInDown"
            >
              <Htag
                tag="h4"
                align={HtagAlign.center}
                variant={HtagVariant.h4}
                className={styles.development_titleSecond}
              >
                android stack of tech used
              </Htag>
            </AnimationOnScroll>

            <AnimationOnScroll
              delay={0}
              offset={200}
              animateOnce
              duration={1.2}
              animateIn="animate__fadeInDown"
            >
              <Paragraph className={styles.development_textSecond}>
                For the Android we used Kotlin latest version mixed with Java.
                Our team has integrated Google Maps and worked with Google
                Places API.
              </Paragraph>
            </AnimationOnScroll>
          </div>
          <AnimationOnScroll
            delay={0}
            offset={200}
            animateOnce
            duration={1.2}
            animateIn="animate__fadeInDown"
            className={styles.banner}
          >
            <Banner
              Start={<Image alt="kotlin logo" src={kotlin} width={294} height={65} />}
              End={<Image alt="java logo" src={java} width={224} height={140} />}
            />
          </AnimationOnScroll>

          <AnimationOnScroll
            delay={0}
            offset={200}
            animateOnce
            duration={1.2}
            animateIn="animate__fadeInDown"
            className={styles.banner}
          >
            <Banner
              Start={<Image alt="android logo" src={android} width={329} height={184} />}
              End={<Image alt="Google place API logo" src={Place} width={359} height={152} />}
            />
          </AnimationOnScroll>
        </div>
        <div className={styles.development__item}>
          <div className={styles.development_box}>
            <AnimationOnScroll
              delay={0}
              offset={200}
              animateOnce
              duration={1.2}
              animateIn="animate__fadeInDown"
            >
              <Htag
                tag="h4"
                align={HtagAlign.center}
                variant={HtagVariant.h4}
                className={styles.development_titleSecond}
              >
                backend
              </Htag>
            </AnimationOnScroll>

            <AnimationOnScroll
              delay={0}
              offset={200}
              animateOnce
              duration={1.2}
              animateIn="animate__fadeInDown"
            >
              <Paragraph className={styles.development_textSecond}>
                Backend of the LinkApp was written using PHP and Laravel. We’ve
                used Docker to run many containers simultaneously.
              </Paragraph>
            </AnimationOnScroll>
          </div>
          <AnimationOnScroll
            delay={0}
            offset={200}
            animateOnce
            duration={1.2}
            animateIn="animate__fadeInDown"
            className={styles.banner}
          >
            <Banner
              Start={<Image alt="docker logo" src={docker} width={186} height={186} />}
              End={<Image alt="redis logo" src={redis} width={162} height={162} />}
            />
          </AnimationOnScroll>

          <AnimationOnScroll
            delay={0}
            offset={200}
            animateOnce
            duration={1.2}
            animateIn="animate__fadeInDown"
            className={styles.banner}
          >
            <Banner
              Start={<Image alt="php logo" src={php} width={223} height={121} />}
              End={<Image alt="laravel logo" src={laravel} width={223} height={156} />}
            />
          </AnimationOnScroll>
        </div>
      </Container>
    </section>
  );
}
